import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'
import { StrictMode } from 'react'

import { App } from 'app/App'
import { msalConfig } from 'auth/config'
import { ApiProvider } from 'providers/ApiProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const msalInstance = new PublicClientApplication(msalConfig)

export const Root = () => (
  <StrictMode>
    <div id="experience-loop-root">
      <MsalProvider instance={msalInstance}>
        <ApiProvider>
          <QueryClientProvider client={queryClient}>
            <App />
          </QueryClientProvider>
        </ApiProvider>
      </MsalProvider>
    </div>
  </StrictMode>
)
